import React, {useState} from 'react';
import Intro from './components/Intro';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Coverage from './components/Coverage';
import Audience from "./components/Audience";
import WhyUs from "./components/WhyUs";
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
    const [introDone, setIntroDone] = useState(false);

    const handleIntroComplete = () => {
        document.body.style.background = '#ffffff';
        setIntroDone(true);
    };

    return (
        <>
            {!introDone && <Intro onComplete={handleIntroComplete}/>}
            <div style={{
                opacity: introDone ? 1 : 0,
                transition: 'opacity 0.6s ease',
            }}>
                <Navbar/>
                <main className="mt-[65px]">
                    <Hero/>
                    <Services/>
                    <Coverage/>
                    <Audience/>
                    <WhyUs/>
                    <About/>
                    <Contact/>
                </main>
                <Footer/>
            </div>
        </>
    );
}